// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.KanbanBoard_page__ERBe0 {
  width: 100%;
  padding: 12px;
  min-width: 0;
}

.KanbanBoard_toolbar__pOGeU {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.KanbanBoard_filters__V2f9P {
  display: grid;
  grid-template-columns: repeat(3, minmax(190px, 1fr));
  gap: 10px;
  width: min(1180px, 100%);
  min-width: 0;
}

.KanbanBoard_input__B2o9K {
  width: 100%;
}

.KanbanBoard_globalSearch__h0Fck {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.KanbanBoard_filterHint__3D\\+mK {
  padding-left: 4px;
  color: #ad6800;
  font-size: 12px;
  line-height: 1.2;
}

.KanbanBoard_inputSmall__wCzjC {
  width: 100%;
}

.KanbanBoard_select__5l2yk {
  width: 100%;
}

.KanbanBoard_periodFilter__3P-F1 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
  min-width: 0;
}

.KanbanBoard_dateInput__Z3iSl {
  width: 100%;
  min-width: 0;
}

.KanbanBoard_toolbarRight__md3Rb {
  display: flex;
  gap: 10px;
  align-items: center;
}

.KanbanBoard_refreshBtn__Y-pRK {
  border-radius: 10px;
}

.KanbanBoard_exportBtn__2V70O {
  border-radius: 10px;
}

.KanbanBoard_createBtn__tY9-G {
  border-radius: 10px;
}

.KanbanBoard_soundBtn__kyJAv {
  border-radius: 10px;
}

.KanbanBoard_boardWrap__441k9 {
  position: relative;
  width: 100%;
  min-width: 0;
  border-radius: 16px;
  background: var(--cl-surface);
}

.KanbanBoard_errorAlert__9FCBk {
  margin-bottom: 12px;
}

.KanbanBoard_legend__c-Vuu {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 10px 8px 6px;
  flex-wrap: wrap;
}

.KanbanBoard_legendItem__ktbmX {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  opacity: 0.9;
}

.KanbanBoard_legendDot__jsxtn {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  display: inline-block;
}

.KanbanBoard_legendWaitingStaff__Faq3t {
  background: #f59e0b;
}

.KanbanBoard_legendWaitingPartner__VeNKE {
  background: #22c55e;
}

.KanbanBoard_columns__FiGw5 {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(300px, 340px);
  gap: 12px;
  overflow-x: auto;
  padding: 6px 4px 12px;
  scroll-snap-type: x mandatory;
}

.KanbanBoard_column__gaX9R {
  background: var(--cl-surface-2);
  border: 1px solid var(--cl-border);
  border-radius: 16px;
  padding: 12px;
  min-width: 0;
  min-height: 70vh;
  scroll-snap-align: start;
}

.KanbanBoard_column__gaX9R[data-readonly=true] .KanbanBoard_card__bokbP {
  cursor: default;
}

/* раскрываемый хедер */
.KanbanBoard_columnHeaderBtn__nMAyi {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.KanbanBoard_columnHeaderLeft__rE8Bi {
  display: flex;
  align-items: center;
  gap: 8px;
}

.KanbanBoard_columnTitle__Ywlhz {
  font-weight: 700;
  font-size: 14px;
}

.KanbanBoard_columnCount__ydFS6 {
  font-size: 12px;
  background: rgba(64, 150, 255, 0.16);
  border: 1px solid rgba(64, 150, 255, 0.26);
  padding: 2px 8px;
  border-radius: 999px;
}

/* chevron */
.KanbanBoard_chevron__ndkU0 {
  width: 10px;
  height: 10px;
  border-right: 2px solid rgba(15, 23, 42, 0.55);
  border-bottom: 2px solid rgba(15, 23, 42, 0.55);
  transform: rotate(45deg);
  transition: transform 160ms ease;
  margin-right: 2px;
}

.KanbanBoard_chevron__ndkU0[data-open=false] {
  transform: rotate(-135deg);
}

.KanbanBoard_assigneeSelect__mPPsn {
  width: 100%;
  margin: 10px 0;
}

.KanbanBoard_sortSelect__jrOQe {
  width: 100%;
  margin: 0 0 10px;
}

.KanbanBoard_activitySelect__-tjp1 {
  width: 100%;
  margin: 0 0 10px;
}

.KanbanBoard_cards__vqi9O {
  display: grid;
  gap: 10px;
}

.KanbanBoard_columnPagination__aK3F\\+ {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.KanbanBoard_emptyColumnState__IvCr7 {
  border: 1px dashed var(--cl-border, #d9dfe8);
  border-radius: 12px;
  padding: 14px 12px;
  font-size: 13px;
  text-align: center;
  opacity: 0.7;
  background: rgba(148, 163, 184, 0.06);
}

.KanbanBoard_card__bokbP {
  background: var(--cl-surface, #ffffff);
  border: 1px solid var(--cl-border, #e7eaf0);
  border-radius: 12px;
  padding: 10px 10px 9px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  cursor: grab;
  min-width: 0;
  -webkit-user-select: none;
          user-select: none;
}

.KanbanBoard_cardWaitingStaff__5yTTs {
  border-left: 4px solid #f59e0b;
  background: #fff9ed;
}

.KanbanBoard_cardWaitingPartner__lGW2Z {
  border-left: 4px solid #22c55e;
  background: #eefcf3;
}

.KanbanBoard_cardTerminalPaymentBlocked__KP5av {
  border-color: #f9a8d4;
  border-left: 4px solid #be185d;
  background: #fff5fa;
}

.KanbanBoard_cardTerminalPaymentBlocked__KP5av.KanbanBoard_cardWaitingStaff__5yTTs {
  border-color: #fcd9a7;
  border-left-color: #f59e0b;
  background: #fff9ed;
}

.KanbanBoard_cardTerminalPaymentBlocked__KP5av.KanbanBoard_cardWaitingPartner__lGW2Z {
  border-color: #b8efca;
  border-left-color: #22c55e;
  background: #eefcf3;
}

body[data-theme="dark"] .KanbanBoard_cardWaitingStaff__5yTTs {
  background: rgba(245, 158, 11, 0.18);
}

body[data-theme="dark"] .KanbanBoard_cardWaitingPartner__lGW2Z {
  background: rgba(34, 197, 94, 0.2);
}

body[data-theme="dark"] .KanbanBoard_cardTerminalPaymentBlocked__KP5av {
  background: rgba(190, 24, 93, 0.2);
}

body[data-theme="dark"] .KanbanBoard_cardTerminalPaymentBlocked__KP5av.KanbanBoard_cardWaitingStaff__5yTTs {
  background: rgba(245, 158, 11, 0.18);
}

body[data-theme="dark"] .KanbanBoard_cardTerminalPaymentBlocked__KP5av.KanbanBoard_cardWaitingPartner__lGW2Z {
  background: rgba(34, 197, 94, 0.2);
}

.KanbanBoard_cardTop__RBkUz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.KanbanBoard_cardId__3SwoK {
  font-weight: 700;
  font-size: 12px;
  opacity: 0.8;
}

.KanbanBoard_cardPriority__YG\\+ri {
  font-size: 12px;
  opacity: 0.75;
}

.KanbanBoard_cardTitle__UPznV {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.28;
  margin-bottom: 9px;
  overflow-wrap: anywhere;
}

.KanbanBoard_cardTags__3XC2E {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
  margin-bottom: 8px;
}

.KanbanBoard_cardTag__v7X4D {
  max-width: 100%;
  padding: 3px 7px;
  border: 1px solid rgba(22, 32, 51, 0.1);
  border-radius: 6px;
  color: #162033;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.KanbanBoard_terminalPaymentBadge__XBu2l {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  margin-bottom: 8px;
  padding: 4px 8px;
  border: 1px solid #fbcfe8;
  border-radius: 8px;
  background: #fce7f3;
  color: #be185d;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.KanbanBoard_ratingBadge__3\\+IRx {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  margin-bottom: 8px;
  padding: 4px 8px;
  border: 1px solid #fde68a;
  border-radius: 8px;
  background: #fffbeb;
  color: #92400e;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.KanbanBoard_cardMeta__XP4af {
  display: grid;
  gap: 5px;
  margin-bottom: 9px;
}

.KanbanBoard_metaRow__A1h8I {
  display: grid;
  grid-template-columns: minmax(72px, auto) minmax(0, 1fr);
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.KanbanBoard_metaLabel__w8XTP {
  font-size: 12px;
  opacity: 0.65;
}

.KanbanBoard_metaValue__mEu02 {
  font-size: 12px;
  text-align: right;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.KanbanBoard_cardAddress__hzY\\+R {
  white-space: normal;
  overflow-wrap: anywhere;
}

.KanbanBoard_detailsBtn__sNNXK {
  width: 100%;
  border-radius: 10px;
}

.KanbanBoard_detailsActions__VSyxx {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
}

.KanbanBoard_detailsBtn__sNNXK,
.KanbanBoard_detailsNewTab__-DWjS {
  min-width: 0;
}

.KanbanBoard_detailsNewTab__-DWjS {
  white-space: nowrap;
}

/* кнопка show more */
.KanbanBoard_showMoreBtn__GokEr {
  width: 100%;
  margin-top: 10px;
  border-radius: 10px;
}

body[data-theme="dark"] .KanbanBoard_refreshBtn__Y-pRK, body[data-theme="dark"] .KanbanBoard_refreshBtn__Y-pRK:hover, body[data-theme="dark"] .KanbanBoard_refreshBtn__Y-pRK:focus, body[data-theme="dark"] .KanbanBoard_refreshBtn__Y-pRK:active,
body[data-theme="dark"] .KanbanBoard_exportBtn__2V70O,
body[data-theme="dark"] .KanbanBoard_exportBtn__2V70O:hover,
body[data-theme="dark"] .KanbanBoard_exportBtn__2V70O:focus,
body[data-theme="dark"] .KanbanBoard_exportBtn__2V70O:active,
body[data-theme="dark"] .KanbanBoard_soundBtn__kyJAv,
body[data-theme="dark"] .KanbanBoard_soundBtn__kyJAv:hover,
body[data-theme="dark"] .KanbanBoard_soundBtn__kyJAv:focus,
body[data-theme="dark"] .KanbanBoard_soundBtn__kyJAv:active,
body[data-theme="dark"] .KanbanBoard_detailsBtn__sNNXK,
body[data-theme="dark"] .KanbanBoard_detailsBtn__sNNXK:hover,
body[data-theme="dark"] .KanbanBoard_detailsBtn__sNNXK:focus,
body[data-theme="dark"] .KanbanBoard_detailsBtn__sNNXK:active,
body[data-theme="dark"] .KanbanBoard_detailsNewTab__-DWjS,
body[data-theme="dark"] .KanbanBoard_detailsNewTab__-DWjS:hover,
body[data-theme="dark"] .KanbanBoard_detailsNewTab__-DWjS:focus,
body[data-theme="dark"] .KanbanBoard_detailsNewTab__-DWjS:active,
body[data-theme="dark"] .KanbanBoard_showMoreBtn__GokEr,
body[data-theme="dark"] .KanbanBoard_showMoreBtn__GokEr:hover,
body[data-theme="dark"] .KanbanBoard_showMoreBtn__GokEr:focus,
body[data-theme="dark"] .KanbanBoard_showMoreBtn__GokEr:active {
  color: var(--cl-dark) !important;
}
body[data-theme="dark"] .KanbanBoard_refreshBtn__Y-pRK span,
body[data-theme="dark"] .KanbanBoard_exportBtn__2V70O span,
body[data-theme="dark"] .KanbanBoard_soundBtn__kyJAv span,
body[data-theme="dark"] .KanbanBoard_detailsBtn__sNNXK span,
body[data-theme="dark"] .KanbanBoard_detailsNewTab__-DWjS span,
body[data-theme="dark"] .KanbanBoard_showMoreBtn__GokEr span {
  color: black !important;
}
body[data-theme="dark"] .KanbanBoard_createBtn__tY9-G, body[data-theme="dark"] .KanbanBoard_createBtn__tY9-G:hover, body[data-theme="dark"] .KanbanBoard_createBtn__tY9-G:focus, body[data-theme="dark"] .KanbanBoard_createBtn__tY9-G:active {
  color: #fff !important;
}
body[data-theme="dark"] .KanbanBoard_createBtn__tY9-G span {
  color: inherit !important;
}

@media (min-width: 901px) {
  .KanbanBoard_columnHeaderBtn__nMAyi {
    cursor: default;
  }
  .KanbanBoard_chevron__ndkU0 {
    display: none;
  }
}
/* --- Mobile --- */
@media (max-width: 900px) {
  .KanbanBoard_filters__V2f9P {
    grid-template-columns: 1fr;
  }
  .KanbanBoard_periodFilter__3P-F1 {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .KanbanBoard_toolbarRight__md3Rb {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    justify-content: stretch;
  }
  .KanbanBoard_boardWrap__441k9 {
    background: transparent;
    border-radius: 0;
  }
  .KanbanBoard_columns__FiGw5 {
    /* вместо горизонтального скролла */
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-x: visible;
    padding: 0;
    scroll-snap-type: none;
  }
  .KanbanBoard_column__gaX9R {
    min-height: auto;
    width: 100%;
    scroll-snap-align: unset;
  }
  .KanbanBoard_metaValue__mEu02 {
    max-width: 100%;
  }
}
@media (max-width: 420px) {
  .KanbanBoard_page__ERBe0 {
    padding: 8px;
  }
  .KanbanBoard_column__gaX9R {
    padding: 10px;
    border-radius: 14px;
  }
  .KanbanBoard_detailsActions__VSyxx {
    gap: 6px;
  }
  .KanbanBoard_detailsBtn__sNNXK,
  .KanbanBoard_detailsNewTab__-DWjS {
    font-size: 12px;
    padding-inline: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/BoardPage/KanbanBoard.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,aAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,wBAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;AAEF;;AACA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,aAAA;EACA,oDAAA;EACA,QAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;AAEF;;AACA;EACE,+BAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;AAEF;;AAEE;EACE,eAAA;AACJ;;AAGA,uBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EAEA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;EACA,oCAAA;EACA,0CAAA;EACA,gBAAA;EACA,oBAAA;AADF;;AAIA,YAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,8CAAA;EACA,+CAAA;EACA,wBAAA;EACA,gCAAA;EACA,iBAAA;AADF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,WAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,qCAAA;AAAF;;AAGA;EACE,sCAAA;EACA,2CAAA;EACA,mBAAA;EACA,sBAAA;EACA,6CAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,8BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,8BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,0BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,0BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,kCAAA;AAAF;;AAGA;EACE,kCAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,kCAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,aAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,wDAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,aAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,oDAAA;EACA,QAAA;AAAF;;AAGA;;EAEE,YAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA,qBAAA;AACA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAUI;;;;;;;;;;;;;;;;;;;;;EAIE,gCAAA;AAUN;AAPI;;;;;;EACE,uBAAA;AAcN;AATI;EAIE,sBAAA;AAQN;AALI;EACE,yBAAA;AAON;;AAFA;EACE;IACE,eAAA;EAKF;EAHA;IACE,aAAA;EAKF;AACF;AAHA,mBAAA;AACA;EACE;IACE,0BAAA;EAKF;EAFA;IACE,oDAAA;EAIF;EADA;IACE,WAAA;IACA,aAAA;IACA,oDAAA;IACA,wBAAA;EAGF;EAAA;IACE,uBAAA;IACA,gBAAA;EAEF;EACA;IACE,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IAEA,mBAAA;IACA,UAAA;IACA,sBAAA;EAAF;EAGA;IACE,gBAAA;IACA,WAAA;IACA,wBAAA;EADF;EAIA;IACE,eAAA;EAFF;AACF;AAKA;EACE;IACE,YAAA;EAHF;EAMA;IACE,aAAA;IACA,mBAAA;EAJF;EAOA;IACE,QAAA;EALF;EAQA;;IAEE,eAAA;IACA,mBAAA;EANF;AACF","sourcesContent":[".page {\n  width: 100%;\n  padding: 12px;\n  min-width: 0;\n}\n\r\n.toolbar {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.filters {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(190px, 1fr));\n  gap: 10px;\n  width: min(1180px, 100%);\n  min-width: 0;\n}\n\r\n.input {\n  width: 100%;\n}\n\n.globalSearch {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.filterHint {\n  padding-left: 4px;\n  color: #ad6800;\n  font-size: 12px;\n  line-height: 1.2;\n}\n\r\n.inputSmall {\r\n  width: 100%;\r\n}\r\n\r\n.select {\n  width: 100%;\n}\n\n.periodFilter {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 8px;\n  min-width: 0;\n}\n\n.dateInput {\n  width: 100%;\n  min-width: 0;\n}\n\r\n.toolbarRight {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.refreshBtn {\n  border-radius: 10px;\n}\n\n.exportBtn {\n  border-radius: 10px;\n}\n\r\n.createBtn {\r\n  border-radius: 10px;\r\n}\r\n\r\n.soundBtn {\r\n  border-radius: 10px;\r\n}\r\n\r\n.boardWrap {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  border-radius: 16px;\n  background: var(--cl-surface);\n}\n\n.errorAlert {\n  margin-bottom: 12px;\n}\n\r\n.legend {\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: center;\r\n  padding: 10px 8px 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.legendItem {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 12px;\r\n  opacity: 0.9;\r\n}\r\n\r\n.legendDot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 999px;\r\n  display: inline-block;\r\n}\r\n\r\n.legendWaitingStaff {\r\n  background: #f59e0b;\r\n}\r\n\r\n.legendWaitingPartner {\r\n  background: #22c55e;\r\n}\r\n\r\n.columns {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: minmax(300px, 340px);\n  gap: 12px;\n  overflow-x: auto;\n  padding: 6px 4px 12px;\r\n  scroll-snap-type: x mandatory;\r\n}\r\n\r\n.column {\n  background: var(--cl-surface-2);\n  border: 1px solid var(--cl-border);\n  border-radius: 16px;\n  padding: 12px;\n  min-width: 0;\n  min-height: 70vh;\n  scroll-snap-align: start;\n}\n\r\n.column[data-readonly=\"true\"] {\r\n  .card {\r\n    cursor: default;\r\n  }\r\n}\r\n\r\n/* раскрываемый хедер */\r\n.columnHeaderBtn {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n\r\n  background: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.columnHeaderLeft {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.columnTitle {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n}\r\n\r\n.columnCount {\r\n  font-size: 12px;\r\n  background: rgba(64, 150, 255, 0.16);\r\n  border: 1px solid rgba(64, 150, 255, 0.26);\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n}\r\n\r\n/* chevron */\r\n.chevron {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-right: 2px solid rgba(15,23,42,0.55);\r\n  border-bottom: 2px solid rgba(15,23,42,0.55);\r\n  transform: rotate(45deg);\r\n  transition: transform 160ms ease;\r\n  margin-right: 2px;\r\n}\r\n.chevron[data-open=\"false\"] {\r\n  transform: rotate(-135deg);\r\n}\r\n\r\n.assigneeSelect {\r\n  width: 100%;\r\n  margin: 10px 0;\r\n}\r\n\r\n.sortSelect {\n  width: 100%;\n  margin: 0 0 10px;\n}\n\n.activitySelect {\n  width: 100%;\n  margin: 0 0 10px;\n}\n\n.cards {\n  display: grid;\n  gap: 10px;\n}\n\n.columnPagination {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.emptyColumnState {\n  border: 1px dashed var(--cl-border, #d9dfe8);\n  border-radius: 12px;\n  padding: 14px 12px;\n  font-size: 13px;\n  text-align: center;\n  opacity: 0.7;\n  background: rgba(148, 163, 184, 0.06);\n}\n\n.card {\n  background: var(--cl-surface, #ffffff);\n  border: 1px solid var(--cl-border, #e7eaf0);\n  border-radius: 12px;\n  padding: 10px 10px 9px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);\n  cursor: grab;\n  min-width: 0;\n  user-select: none;\n}\n\r\n.cardWaitingStaff {\r\n  border-left: 4px solid #f59e0b;\r\n  background: #fff9ed;\r\n}\r\n\r\n.cardWaitingPartner {\n  border-left: 4px solid #22c55e;\n  background: #eefcf3;\n}\n\n.cardTerminalPaymentBlocked {\n  border-color: #f9a8d4;\n  border-left: 4px solid #be185d;\n  background: #fff5fa;\n}\n\n.cardTerminalPaymentBlocked.cardWaitingStaff {\n  border-color: #fcd9a7;\n  border-left-color: #f59e0b;\n  background: #fff9ed;\n}\n\n.cardTerminalPaymentBlocked.cardWaitingPartner {\n  border-color: #b8efca;\n  border-left-color: #22c55e;\n  background: #eefcf3;\n}\n\n:global(body[data-theme=\"dark\"]) .cardWaitingStaff {\n  background: rgba(245, 158, 11, 0.18);\n}\n\n:global(body[data-theme=\"dark\"]) .cardWaitingPartner {\n  background: rgba(34, 197, 94, 0.2);\n}\n\n:global(body[data-theme=\"dark\"]) .cardTerminalPaymentBlocked {\n  background: rgba(190, 24, 93, 0.2);\n}\n\n:global(body[data-theme=\"dark\"]) .cardTerminalPaymentBlocked.cardWaitingStaff {\n  background: rgba(245, 158, 11, 0.18);\n}\n\n:global(body[data-theme=\"dark\"]) .cardTerminalPaymentBlocked.cardWaitingPartner {\n  background: rgba(34, 197, 94, 0.2);\n}\n\r\n.cardTop {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.cardId {\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  opacity: 0.8;\r\n}\r\n\r\n.cardPriority {\r\n  font-size: 12px;\r\n  opacity: 0.75;\r\n}\r\n\r\n.cardTitle {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.28;\n  margin-bottom: 9px;\n  overflow-wrap: anywhere;\n}\n\n.cardTags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  min-width: 0;\n  margin-bottom: 8px;\n}\n\n.cardTag {\n  max-width: 100%;\n  padding: 3px 7px;\n  border: 1px solid rgba(22, 32, 51, 0.1);\n  border-radius: 6px;\n  color: #162033;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.terminalPaymentBadge {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  margin-bottom: 8px;\n  padding: 4px 8px;\n  border: 1px solid #fbcfe8;\n  border-radius: 8px;\n  background: #fce7f3;\n  color: #be185d;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.ratingBadge {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  margin-bottom: 8px;\n  padding: 4px 8px;\n  border: 1px solid #fde68a;\n  border-radius: 8px;\n  background: #fffbeb;\n  color: #92400e;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.cardMeta {\n  display: grid;\n  gap: 5px;\n  margin-bottom: 9px;\n}\n\n.metaRow {\n  display: grid;\n  grid-template-columns: minmax(72px, auto) minmax(0, 1fr);\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n\r\n.metaLabel {\r\n  font-size: 12px;\r\n  opacity: 0.65;\r\n}\r\n\r\n.metaValue {\n  font-size: 12px;\n  text-align: right;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cardAddress {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\r\n.detailsBtn {\r\n  width: 100%;\r\n  border-radius: 10px;\r\n}\r\n\r\n.detailsActions {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 8px;\n}\n\n.detailsBtn,\n.detailsNewTab {\n  min-width: 0;\n}\n\n.detailsNewTab {\n  white-space: nowrap;\n}\n\r\n/* кнопка show more */\r\n.showMoreBtn {\r\n  width: 100%;\r\n  margin-top: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n:global(body[data-theme=\"dark\"]) {\r\n  .refreshBtn,\n  .exportBtn,\n  .soundBtn,\n  .detailsBtn,\r\n  .detailsNewTab,\r\n  .showMoreBtn {\r\n    &,\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      color: var(--cl-dark) !important;\r\n    }\r\n\r\n    :global(span) {\r\n      color: black !important;\r\n    }\r\n  }\r\n\r\n  .createBtn {\r\n    &,\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      color: #fff !important;\r\n    }\r\n\r\n    :global(span) {\r\n      color: inherit !important;\r\n    }\r\n  }\r\n}\r\n\r\n@media (min-width: 901px) {\r\n  .columnHeaderBtn {\r\n    cursor: default;\r\n  }\r\n  .chevron {\r\n    display: none;\r\n  }\r\n}\r\n/* --- Mobile --- */\r\n@media (max-width: 900px) {\r\n  .filters {\n    grid-template-columns: 1fr;\n  }\n\n  .periodFilter {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  .toolbarRight {\n    width: 100%;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    justify-content: stretch;\n  }\n\n  .boardWrap {\n    background: transparent;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .columns {\r\n    /* вместо горизонтального скролла */\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n\r\n    overflow-x: visible;\r\n    padding: 0;\r\n    scroll-snap-type: none;\r\n  }\r\n\r\n  .column {\n    min-height: auto;\n    width: 100%;\n    scroll-snap-align: unset;\n  }\n\n  .metaValue {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 420px) {\n  .page {\n    padding: 8px;\n  }\n\n  .column {\n    padding: 10px;\n    border-radius: 14px;\n  }\n\n  .detailsActions {\n    gap: 6px;\n  }\n\n  .detailsBtn,\n  .detailsNewTab {\n    font-size: 12px;\n    padding-inline: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `KanbanBoard_page__ERBe0`,
	"toolbar": `KanbanBoard_toolbar__pOGeU`,
	"filters": `KanbanBoard_filters__V2f9P`,
	"input": `KanbanBoard_input__B2o9K`,
	"globalSearch": `KanbanBoard_globalSearch__h0Fck`,
	"filterHint": `KanbanBoard_filterHint__3D+mK`,
	"inputSmall": `KanbanBoard_inputSmall__wCzjC`,
	"select": `KanbanBoard_select__5l2yk`,
	"periodFilter": `KanbanBoard_periodFilter__3P-F1`,
	"dateInput": `KanbanBoard_dateInput__Z3iSl`,
	"toolbarRight": `KanbanBoard_toolbarRight__md3Rb`,
	"refreshBtn": `KanbanBoard_refreshBtn__Y-pRK`,
	"exportBtn": `KanbanBoard_exportBtn__2V70O`,
	"createBtn": `KanbanBoard_createBtn__tY9-G`,
	"soundBtn": `KanbanBoard_soundBtn__kyJAv`,
	"boardWrap": `KanbanBoard_boardWrap__441k9`,
	"errorAlert": `KanbanBoard_errorAlert__9FCBk`,
	"legend": `KanbanBoard_legend__c-Vuu`,
	"legendItem": `KanbanBoard_legendItem__ktbmX`,
	"legendDot": `KanbanBoard_legendDot__jsxtn`,
	"legendWaitingStaff": `KanbanBoard_legendWaitingStaff__Faq3t`,
	"legendWaitingPartner": `KanbanBoard_legendWaitingPartner__VeNKE`,
	"columns": `KanbanBoard_columns__FiGw5`,
	"column": `KanbanBoard_column__gaX9R`,
	"card": `KanbanBoard_card__bokbP`,
	"columnHeaderBtn": `KanbanBoard_columnHeaderBtn__nMAyi`,
	"columnHeaderLeft": `KanbanBoard_columnHeaderLeft__rE8Bi`,
	"columnTitle": `KanbanBoard_columnTitle__Ywlhz`,
	"columnCount": `KanbanBoard_columnCount__ydFS6`,
	"chevron": `KanbanBoard_chevron__ndkU0`,
	"assigneeSelect": `KanbanBoard_assigneeSelect__mPPsn`,
	"sortSelect": `KanbanBoard_sortSelect__jrOQe`,
	"activitySelect": `KanbanBoard_activitySelect__-tjp1`,
	"cards": `KanbanBoard_cards__vqi9O`,
	"columnPagination": `KanbanBoard_columnPagination__aK3F+`,
	"emptyColumnState": `KanbanBoard_emptyColumnState__IvCr7`,
	"cardWaitingStaff": `KanbanBoard_cardWaitingStaff__5yTTs`,
	"cardWaitingPartner": `KanbanBoard_cardWaitingPartner__lGW2Z`,
	"cardTerminalPaymentBlocked": `KanbanBoard_cardTerminalPaymentBlocked__KP5av`,
	"cardTop": `KanbanBoard_cardTop__RBkUz`,
	"cardId": `KanbanBoard_cardId__3SwoK`,
	"cardPriority": `KanbanBoard_cardPriority__YG+ri`,
	"cardTitle": `KanbanBoard_cardTitle__UPznV`,
	"cardTags": `KanbanBoard_cardTags__3XC2E`,
	"cardTag": `KanbanBoard_cardTag__v7X4D`,
	"terminalPaymentBadge": `KanbanBoard_terminalPaymentBadge__XBu2l`,
	"ratingBadge": `KanbanBoard_ratingBadge__3+IRx`,
	"cardMeta": `KanbanBoard_cardMeta__XP4af`,
	"metaRow": `KanbanBoard_metaRow__A1h8I`,
	"metaLabel": `KanbanBoard_metaLabel__w8XTP`,
	"metaValue": `KanbanBoard_metaValue__mEu02`,
	"cardAddress": `KanbanBoard_cardAddress__hzY+R`,
	"detailsBtn": `KanbanBoard_detailsBtn__sNNXK`,
	"detailsActions": `KanbanBoard_detailsActions__VSyxx`,
	"detailsNewTab": `KanbanBoard_detailsNewTab__-DWjS`,
	"showMoreBtn": `KanbanBoard_showMoreBtn__GokEr`
};
export default ___CSS_LOADER_EXPORT___;
